var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeterWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6509 5.65078L7.6509 4.65078M5.1509 4.15078L6.1509 3.15078M3.6509 2.65078L4.6509 1.65078M8.1509 7.15078L9.1509 6.15078M10.0509 7.05078C10.1628 7.16226 10.2515 7.29474 10.3121 7.4406C10.3727 7.58646 10.4038 7.74284 10.4038 7.90078C10.4038 8.05872 10.3727 8.2151 10.3121 8.36096C10.2515 8.50682 10.1628 8.6393 10.0509 8.75078L8.7509 10.0508C8.63942 10.1627 8.50695 10.2514 8.36108 10.312C8.21522 10.3725 8.05884 10.4037 7.9009 10.4037C7.74296 10.4037 7.58658 10.3725 7.44072 10.312C7.29486 10.2514 7.16239 10.1627 7.0509 10.0508L0.750902 3.75078C0.52618 3.52497 0.400024 3.21936 0.400024 2.90078C0.400024 2.5822 0.52618 2.27659 0.750902 2.05078L2.0509 0.75078C2.27671 0.526058 2.58233 0.399902 2.9009 0.399902C3.21948 0.399902 3.52509 0.526058 3.7509 0.75078L10.0509 7.05078Z",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeterWhite);
export default __webpack_public_path__ + "static/media/meterWhite.f273f84119cc5654c9643c276f9e73a7.svg";
export { ForwardRef as ReactComponent };